import { Gauge, GaugeProps } from "components";

const QUANTUM_INDEX_MAX = 100;
const QUANTUM_INDEX_WARNING_THRESHOLD = 74;

type QuantumIndexGaugeProps = {
  value: number;
} & Pick<GaugeProps, "thickness" | "fontSize">;

export const QuantumIndexGauge = ({
  value,
  thickness,
  fontSize,
}: QuantumIndexGaugeProps) => (
  <Gauge
    value={value}
    max={QUANTUM_INDEX_MAX}
    color={value >= QUANTUM_INDEX_WARNING_THRESHOLD ? "teal.500" : "yellow.500"}
    thickness={thickness}
    fontSize={fontSize}
  />
);
